import type { AnalyticsSurface } from '@/shared/surfaces/AnalyticsSurface';
import ClassificationSurfaceCard from '@/features/classification/ClassificationSurfaceCard';
import { BEHAVIOR_CATALOG } from './BehaviorTopicCatalog';

/** The Behavior surface: an interior-nav shell over the analytics views (use cases first), with the turn feed at the bottom and side-rail drill-ins. Adoption is now its own top-level surface. */
export const BEHAVIOR_SURFACE: AnalyticsSurface = {
    id: 'behavior',
    basePath: '/behavior',
    title: 'Behavior',
    subtitle: 'The behavioral picture — what kinds of work flow through, model fit, and how activity moves over time.',
    catalog: [...BEHAVIOR_CATALOG],
    gallery: { statTiles: ['turns', 'sessions', 'users', 'avgOutputTokens'], lead: 'inline-viz', featuredTopicId: 'difficulty-mix', cardStyle: 'standard', columns: { base: 1, md: 2, xl: 3 }, signals: true },
    assist: true,
    assistScope:
        'This surface is about behavioral usage and adoption: what kinds of work flow through (task_category, task_subcategory), how hard it is (difficulty), which models people reach for (model), who is doing the work (user_id, user_department, user_title, user_org_unit), how many distinct people are active (reach/adoption), and how activity moves over time. Prefer these fields and behavioral/reach framings. Token spend, cost, and governance/compliance asks belong to other surfaces — answer them behaviorally here (e.g. activity volume or active people, not dollars).',
    assistInspiration: [
        'What is AI actually being used for?',
        'Break down activity by difficulty',
        'Which models handle which kinds of work?',
        'Which teams have embraced AI?',
        'Activity over time',
    ],
    drillStyle: 'side-rail',
    trailingCard: <ClassificationSurfaceCard category="Usage" variant="standard" />,
};
